export default function shouldGetCountries(query) {
  return hasNoPlace(query) && isNotVolumeSetSearch(query) && isRecordSearch()
}

function hasNoPlace(query) {
  return !Object.prototype.hasOwnProperty.call(query, 'place')
}

function isNotVolumeSetSearch(query) {
  return !Object.prototype.hasOwnProperty.call(query, 'volumeSetSearch')
}

function isRecordSearch() {
  const BASE_URL = '/images/search-results'
  const path = window.location.pathname
  return path.includes(BASE_URL)
}
